import { Theme as AugmentedTheme } from '@material-ui/core/styles';

const styles = (theme: AugmentedTheme) => {
  return {
    root: {
      borderColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: '#d1f0e5'
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    sizeSmall: {
      width: 40,
      height: 32,
      '& svg': {
        width: 18,
        height: 18
      }
    }
  };
};

export default styles;
